<template lang='pug'>
  bf-wrapper.content.add-order-dialog.component
    h4.heading {{ $t("Add a New Order") }}

    bf-input
      input(type='search' :placeholder="$t('Customer Email')" v-model='email')
      template(v-slot:icon)
        search-icon
    .customers(v-show='email')
      .customer(
        v-for='c in customers'
        :class='{ selected: c.id == customer_id }'
        @click='customer_id = c.id'
      ) {{ c.email }}:  {{ c.name }}

    base-card#services
      services-card(
        :categories='categories'
        :srvs='srvs'
        v-model='service_id'
      )

    new-order-dialog(
      :business='biz'
      :account='account'
      :user='user'
      :service_id='service_id'
      :customer='customer'
      @close='show.reserve = false'
      @notify='notify'
    )
</template>

<script>
  import { db } from '@/main'
  import NewOrderDialog from '@/components/new-order-dialog'
  import BaseCard from '@/components/base-card'
  import ServicesCard from '@/components/services-card'

  export default {
    name: 'add-order-dialog.component',

    props: {
      biz: { type: Object, default: () => ({}) },
      account: { type: Object, default: () => ({}) },
      user: { type: Object, default: () => ({}) }
    },

    components: {
      BaseCard,
      ServicesCard,
      NewOrderDialog
    },

    data() {
      return {
        email: '',
        service_id: '',
        customers: [],
        customer_id: '',
        show: {reserve: false}
      }
    },

    firestore() {
      return {
        customers: db.collection('customers').where( 'business_id', '==', this.biz.id ),
        services: db.collection ('services').where( 'business_id', '==', this.biz.id ),
        categories: db.collection('categories').where( 'account_id', '==', this.account.id )
      }
    },

    computed: {
      customer() {
        return this.customers.find( c => c.id == this.customer_id )
      },

      srvs() {
        if ( !this.category_id ) return this.services
        else return this.services.filter( s => s.category_id == this.category_id )
      }
    },

    methods: {
      notify(message) {
        this.$emit("notify", message)
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .add-order-dialog
    .heading
      margin-bottom 0px
      margin-top -30px
      color white

    #services
      margin 10px 0 32px 0

    .customers
      padding 1px
      overflow hidden
      background white
      color black
      .customer
        border-bottom 1px solid rgba( 0 0 0 .04 )
        border-top 1px solid rgba( 255 255 255 .5 )
        cursor pointer
        padding 5px 16px
        background rgba( 0 0 0 .04 )
        &.selected
          background rgba( 50 175 200 .75)
          color white
          border-bottom-color rgba( 0 0 0 .1 )
          border-top-color rgba( 255 255 255 1 )

        &:first-child
          border-top 0
          border-radius 12px 12px 0 0

        &:last-child
          border-radius 0 0 12px 12px
          // border-bottom 0
    
     >>> .vuecal--week-view, >>> .vuecal--month-view, >>> .vuecal--day-view 
      border 2px solid grey
      border-radius 5px
      background rgb(250 250 250)
    >>> .vuecal__cell--today 
      background rgba(255 255 255 .9)
      font-weight bold
</style>
